import PropTypes from "prop-types";
// components
import Button from "@components/ui/Button";
//Assets
import { synchronyFinancialLogo } from "@assets/images";
// Helpers
import { getSamlLoginRoute } from "@utils/browser-helpers";

const styles = {
  loggedOutAllView: "flex flex-col justify-center",
  syfLogo:
    "object-contain my-0 mx-auto w-full h-auto rounded-[10px] max-h-32 grid overflow-hiddeb items-center",
  loggedOut: "w-full my-0 mx-auto items-center pt-12",
  normalizedText: "w-max m-0 p-0 mt-4",
  loginActin: "!flex-row items-center mt-4 max-w-2xl text-center",
};

const LoggedOutView = ({ mainHeader, text, actionText, action }) => (
  <div
    id="syf-error-logged-out"
    className={`syf-error-logged-out ${styles.loggedOutAllView} ${styles.loggedOut}`}
  >
    <h1
      id="syf-logged-out-title"
      className={`syf-logged-out-title font-body tracking-title-lg leading-title-lg text-opacity-87 font-normal ${styles.normalizedText} text-5xl`}
    >
      {mainHeader}
    </h1>
    <p
      id="syf-logged-out-main-text"
      className={`syf-logged-out-main-text font-normal text-lg font-body tracking-tertiary leading-tertiary text-black ${styles.normalizedText}`}
    >
      {text}
    </p>
    <div
      id="syf-error-log-in-again"
      className={`syf-error-log-in-again ${styles.loginActin} ${styles.loggedOutAllView} `}
    >
      <p
        id="syf-logged-out-action-text"
        className={`syf-logged-out-action-text font-normal text-lg font-body tracking-tertiary leading-tertiary text-black !mt-0 ${styles.normalizedText} `}
      >
        {actionText}
      </p>
      {action}
    </div>
  </div>
);

const ERROR_PAGE_TEXT = {
  LOGGED_OUT: {
    mainHeader: "Control Center",
    text: "You have been successfully logged out of Control Center.",
    actionText: "A bit more to do?",
    action: (
      <a href={getSamlLoginRoute()}>
        <Button
          className="syf-login-action"
          componentID="syf-login-action"
          ariaLabel="Log In"
          label="Log In"
          customStyle={
            "w-max pt-3 pr-5 inline-flex items-center justify-center ml-6"
          }
          theme="secondary"
          key="0"
        />
      </a>
    ),
  },
  NO_CRED: {
    mainHeader: "Control Center",
    text: "",
    actionText: "",
    action: (
      <span className="text-md-2 font-body tracking-body-text leading-body-text font-normal text-opacity-87">
        Your SSO or username does not have the required permissions to access
        Control Center. For assistance, please reach out to the{" "}
        <a
          className={"no-underline"}
          href="mailto:alexander.bronze@gpshopper.com?Subject=SSO/Username Assistance"
        >
          Control Center DAP team
        </a>
      </span>
    ),
  },
};

const LoggedOutAllView = ({ searchParams = {} }) => {
  return (
    <div className={`error-page-all-view ${styles.loggedOutAllView}`}>
      <div id="syf-logo-container" className="syf-logo-container w-80 h-32">
        <img
          src={synchronyFinancialLogo}
          alt="Synchrony Financial Logo"
          className={styles.syfLogo}
        />
      </div>
      <LoggedOutView
        {...ERROR_PAGE_TEXT[
          (searchParams && searchParams.error) || "LOGGED_OUT"
        ]}
      />
    </div>
  );
};

LoggedOutAllView.propTypes = {
  /** Error page type */
  searchParams: PropTypes.object,
};

export default LoggedOutAllView;
